import React, { useState } from "react";
import SearchIcon from "../../assets/svgs/Search";
import RemoveIcon from "../../assets/svgs/Remove";
import MessageIcon from "../../assets/svgs/Message";
import NotificationIcon from "../../assets/svgs/Notification";
import PlusIcon from "../../assets/svgs/Plus";
import ChevronDownIcon from "../../assets/svgs/ChevronDown";
import Menu from "../../assets/svgs/Menu";
import { useRootContext } from "../../context";
import Notifications from "./Notifications";
import { Link } from "react-router-dom";

const Header = ({ LeftNavRef }) => {
  const { state, dispatch } = useRootContext();
  const [showN, setShowN] = useState(false);

  const [showSearch, setShowSearch] = useState(false);
  const showLeftNav = () => {
    LeftNavRef?.current.classList.remove("slide-left");
    LeftNavRef?.current.classList.add("slide-right");
  };

  return (
    <header
      style={{ height: "96px" }}
      className="flex justify-between items-center"
    >
      <form className="relative space-x-3 hidden lg:flex">
        <button type="submit">
          <SearchIcon />
        </button>
        <input
          className="outline-none bg-transparent border-b-2 pb-3 px-3 focus:border-blue-500 focus:text-blue-500 text-lg"
          type="text"
          placeholder="Search"
        />
      </form>

      <button onClick={showLeftNav} className="md:hidden">
        <Menu />
      </button>

      <div className=" ml-auto flex items-center space-x-5 md:space-x-10 text-gray-500">
        <div className="text-black relative lg:hidden cursor-pointer">
          <button
            className="flex items-center"
            onClick={() => setShowSearch((p) => !p)}
          >
            {showSearch ? <RemoveIcon /> : <SearchIcon />}
          </button>
          {showSearch && (
            <>
              <div
                onClick={() => setShowSearch(false)}
                className="fixed inset-0 z-10 bg-black bg-opacity-20"
              />
              <form className="absolute bg-white p-5 rounded-md -left-5 z-20 top-full flex mt-5">
                <input
                  className="outline-none bg-transparent border-b-2 pb-3 px-3 focus:border-blue-500 focus:text-blue-500 text-lg"
                  type="text"
                  placeholder="Search"
                />
                <button type="submit">
                  <SearchIcon />
                </button>
              </form>
            </>
          )}
        </div>
        <button onClick={() => dispatch({ type: "toggle_support_req" })}>
          {state.showSupportReq ? <RemoveIcon /> : <MessageIcon />}
        </button>
        <div className="relative">
          <div className="absolute inset-x-0 mx-auto -bottom-0 w-1 h-1 p-0.5 rounded-full bg-red-600" />
          <button
            className={`relative z-40`}
            onClick={() => setShowN((p) => !p)}
          >
            <NotificationIcon />
          </button>
          <Notifications showN={showN} setShowN={setShowN} />
        </div>
        <button
          onClick={() => dispatch({ type: "toggle_addpopup" })}
          className="shadow-xl w-9 h-9 rounded-full  flex justify-center items-center bg-gradient-to-tr from-pink-700 to-pink-500 text-white"
        >
          <PlusIcon />
        </button>

        <span className="pr-0.5 h-8 bg-gray-400" />

        <div className="flex items-center space-x-2 cursor-pointer">
          <div className="shadow-xl w-9 h-9 rounded-full bg-gradient-to-tr from-pink-400 to-red-300"></div>
          <ChevronDownIcon />
        </div>
      </div>
    </header>
  );
};

export default Header;
